import { Easing } from '@tweenjs/tween.js'

export { isLocalStorageAvailable, getFromLocalStorage, setToLocalStorage } from './localStorage'
export delayOrSkip from './delayOrSkip'
export gameDelay from './gameDelay'

/**
 * Searches the Querystring for a parameter by the provided name
 * @param name {string} Name of the query parameter
 * @param url {string, optional} Will use window.location.href if ommitted
 * @returns {*} Returns the parameter or null if nothing was found.
 */
export function getParameterByName(name, url) {
  let _url = url
  if (!_url) _url = window.location.href
  const _name = name.replace(/[\[\]]/g, '\\$&')
  const regex = new RegExp(`[?&]${_name}(=([^&#]*)|&|#|$)`)
  const results = regex.exec(_url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

/**
 * Iterates through all the Tween easings and creates and array with string
 * representations of the easing names.
 * @returns {Array} - Returns an array of strings, representing easings.
 */
export function getAvailableEasings() {
  const easingStrings = []
  Object.keys(Easing).forEach(easingGroup => {
    const easeTypes = Easing[easingGroup]
    Object.keys(easeTypes).forEach(easeType => {
      easingStrings.push(`${easingGroup}.${easeType}`)
    })
  })

  return easingStrings
}
/**
 * Finds an easing functions matching the string given.
 * @param {string} easingString - An easing group and type, e.g. 'Bounce.Out'
 * @returns {function} easing - Returns an easing functions.
 */
export function getEasingFunction(easingString) {
  const groups = easingString.split('.')
  const func = Easing[groups[0]][groups[1]]

  if (func) {
    return func
  }

  console.error(`Could not find an easing that matched the string: ${easingString}`)
  return Easing.Linear.None
}

/**
 * Calculates time difference between input time and current time.
 * @param {Number} expiryTime - Unix timestamp in seconds
 * @returns {Number} - Time difference to expiryTime, in milliseconds.
 */
export function timeUntilExpiration(expiryTime) {
  const unixInSeconds = Date.now() / 1000
  return Math.floor((expiryTime - unixInSeconds) * 1000)
}

const Utils = {
  delayOrSkip: require('./delayOrSkip').default,
  gameDelay: require('./gameDelay').default,
  setToLocalStorage: require('./localStorage').setToLocalStorage,
  getFromLocalStorage: require('./localStorage').getFromLocalStorage,
  isLocalStorageAvailable: require('./localStorage').isLocalStorageAvailable,
  getParameterByName,
  getAvailableEasings,
  getEasingFunction,
  timeUntilExpiration,
}

export default Utils
